export default __webpack_public_path__ + "static/media/no-refund-icon.efd26a07.svg";